import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function Reviews() {
  const reviews = [
    { name: "Sarah J.", role: "Executive Chef", text: "The balance on the 8-inch chef's knife is impeccable. It feels like an extension of my arm during a busy service." },
    { name: "Mike T.", role: "Home Cook", text: "Finally upgraded to the Carbon Steel Wok. The sear I get on meats now is restaurant quality. Worth every penny." },
    { name: "Elena R.", role: "Pastry Chef", text: "The prep station board is gorgeous and incredibly functional. It stays put and is gentle on all my precision tools." }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-zinc-800 mb-16">Trusted by Pros & Enthusiasts</h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-[#faf9f6] p-8 rounded-sm border border-zinc-100 relative"
            >
              <SafeIcon icon="FiMessageSquare" className="absolute top-4 right-4 text-zinc-200 text-4xl" />
              <div className="flex text-red-500 mb-4">
                {[...Array(5)].map((_, j) => <SafeIcon key={j} icon="FiStar" className="fill-current" />)}
              </div>
              <p className="text-zinc-700 italic mb-6 relative z-10">"{review.text}"</p>
              <div>
                <p className="font-bold text-zinc-900">{review.name}</p>
                <p className="text-sm text-zinc-500">{review.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}